import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../base-template-editor/template-editor.component';

@Component({
    selector: 'app-sms-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/sms-template/"
      channelLabel="SMS"
      namePlaceholder="Enter sms name"
      emptyMessage="No sms found!"
      heartbeatType="sms"
      [showResponsysButton]="true"
      [supportsMediaDeletion]="false"
      [defaultBlocks]="defaultBlocks" />
  `
})
export class SmsTemplateComponent {
  protected readonly templateType = TypeEnum.SMS;

  protected readonly defaultBlocks: { name: string; variables: Record<string, string> }[] = [
    { name: 'sms', variables: { Sms: '', SmsCtaLink: '' } },
  ];
}
